import { storageResources } from '../../../mocks/storage';

const StorageResources = () => {
  return (
    <section className="py-16 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-neutral-800 mb-4">
            仓储资源展示
          </h2>
          <p className="text-lg text-neutral-600 mb-2">
            重点强调"合规性"
          </p>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 max-w-3xl mx-auto">
            <p className="text-amber-800 font-medium">
              仓储资源是否可用于 1039，取决于其是否具备"合规留痕能力"
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {storageResources.map((storage) => (
            <div
              key={storage.id}
              className="bg-white rounded-xl border border-neutral-200 p-6 hover:shadow-lg transition-all duration-300"
            >
              <div className="mb-4">
                <h3 className="text-xl font-bold text-neutral-800 mb-2">
                  {storage.type}
                </h3>
                <div className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-[#F7931E]"></i>
                  <span className="text-neutral-600">{storage.location}</span>
                </div>
              </div>

              <div className="space-y-3 mb-6">
                <h4 className="text-sm font-medium text-neutral-700">
                  合规能力标签：
                </h4>
                <div className="space-y-2">
                  {storage.capabilities.map((capability, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-3 text-sm"
                    >
                      <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center">
                        <i className="ri-check-line text-green-600 text-xs"></i>
                      </div>
                      <span className="text-neutral-700">{capability}</span>
                    </div>
                  ))}
                </div>
              </div>

              <p className="text-neutral-600 text-sm">
                {storage.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StorageResources;